import * as React from "react";
import { highlightParts } from "./Searchranking";

/** Text with the searched words in bold. */
export const Highlight: React.FC<{ text: string; tokens: string[] }> = ({ text, tokens }) => (
  <>
    {highlightParts(text, tokens).map((p, i) => (p.on ? <b key={i}>{p.text}</b> : <span key={i}>{p.text}</span>))}
  </>
);